import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../util/wordywhiz";

const FIELDS = [
  { label: "First Name", name: "first_name", type: "text" },
  { label: "Last Name", name: "last_name", type: "text" },
  { label: "Email", name: "email", type: "email" },
  { label: "Username", name: "username", type: "text" },
  { label: "Password", name: "password", type: "password" },
];

function Signup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    username: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  function changeHandler(e) {
    setForm((curr) => ({ ...curr, [e.target.name]: e.target.value }));
  }

  async function submitHandler(e) {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    try {
      await registerUser(form);
      navigate("/wordy-whiz/login", { state: { userData: form } });
    } catch {
      setError("Could not create account. Username may already be taken.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="study-header">
        <p className="study-eyebrow">Wordy Whiz</p>
        <h1>Sign Up</h1>
      </div>

      {error && <p className="auth-error">{error}</p>}

      {isLoading ? (
        <div className="dict-spinner" />
      ) : (
        <form className="auth-form" onSubmit={submitHandler}>
          {FIELDS.map(({ label, name, type }) => (
            <label className="auth-field" key={name}>
              <span className="ww-label">{label}</span>
              <input
                className="auth-input"
                type={type}
                name={name}
                value={form[name]}
                onChange={changeHandler}
                autoCapitalize="none"
                required
              />
            </label>
          ))}
          <div className="auth-actions">
            <button type="submit" className="ww-btn ww-btn--accent">Create Account</button>
          </div>
        </form>
      )}
    </div>
  );
}

export default Signup;
